import { createFileRoute } from '@tanstack/react-router'

import ScreenLayout from '@/components/layout/ScreenLayout'
import TitleRow from '@/components/ui/TitleRow'
import { useLastMinuteMovers } from '@/features/brokers/api/lastMinuteService'
import { useOnline } from '@/hooks/useOnline'
import { resolveViewState } from '@/lib/view-state'
import MoversTable from '@/screens/brokers/components/last-minute/MoversTable'

const HEADER = <TitleRow title="Last Minute Movers" />

export const Route = createFileRoute('/_app/brokers/last-minute')({
  component: LastMinuteScreen,
})

/**
 * Brokers · Last minute movers (V2 `4243:104225`; the revamp mock's `#/brokers/last-minute`):
 * stocks that traded heavily in the last 15 minutes on at least two of the last five sessions,
 * and what share of the day's volume that was.
 *
 * NOTHING BUT THE TABLE, as the mock draws it: no controls, no period, no as-of line, no pager.
 * The section strip names the page.
 *
 * NO ENDPOINT YET. mm-be serves no feed for it, so `LAST_MINUTE_AVAILABLE` is false: the page
 * makes no request and draws its real table head over the generic "Not available yet" state
 * (owner ruling 1 and 2, 2026-10-28; the contract is in `asks/last-minute-movers.md`). The row
 * card, the five-day dots and the five sorts are built and wait on the data.
 */
function LastMinuteScreen() {
  const query = useLastMinuteMovers()
  const online = useOnline()
  const view = resolveViewState(query, {
    isEmpty: (data) => data.rows.length === 0,
    online,
  })

  return (
    <ScreenLayout header={HEADER} pageTitle="Last Minute Movers">
      <MoversTable
        data={query.data}
        view={view}
        onRetry={() => void query.refetch()}
        retrying={query.isFetching}
        savedAt={query.dataUpdatedAt}
      />
    </ScreenLayout>
  )
}
